import axios from 'axios';

const rawBaseUrl = process.env.REACT_APP_API_URL || 'https://api.iskenderun.bel.tr/api';
const baseUrl = rawBaseUrl.endsWith('/api') ? rawBaseUrl : `${rawBaseUrl}/api`;

export const getActiveTenders = async (pageNum = 1, pageSize = 20, searchTerm = '', sortBy = '') => {
  try {
    const response = await axios.post(`${baseUrl}/Tender/GetActiveTenders`, {
      pageNum,
      pageSize,
      searchTerm,
      sortBy,
      startDate: "2000-01-01T00:00:00.000Z",
      endDate: new Date(new Date().setFullYear(new Date().getFullYear() + 10)).toISOString()
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching active tenders:', error);
    throw error;
  }
};

export const getTenderByGuid = async (guid) => {
  try {
    console.log('Sending request with guid:', guid);
    const response = await axios.post(`${baseUrl}/Tender/GetTendersByGuid`, {
      guid: guid
    });
    console.log('Response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching tender details:', error.response?.data || error.message);
    throw error;
  }
};
